import { MEASURE_NAMES, SKILL_NAMES } from '../../constants/assessments';
import { DISCONTINUE_RULE, SCORE_RULE } from './constants';
import bmRecommendationRuleFactory from './bmRecommendationRuleFactory';

const recommendationRules = {
    [MEASURE_NAMES.FSLIK]: {
        rules: [
            {
                name: DISCONTINUE_RULE,
                measure: MEASURE_NAMES.FSL,
                skill: SKILL_NAMES.SONIDOS_DE_LETRAS,
            },
            {
                name: SCORE_RULE,
                measure: MEASURE_NAMES.FSL,
                skill: SKILL_NAMES.SONIDOS_DE_LETRAS,
                score: 0,
            },
        ],
    },
    [MEASURE_NAMES.FSLI]: {
        rules: [
            {
                name: DISCONTINUE_RULE,
                measure: MEASURE_NAMES.FSL,
                skill: SKILL_NAMES.SONIDOS_DE_LETRAS,
            },
            {
                name: SCORE_RULE,
                measure: MEASURE_NAMES.FSL,
                skill: SKILL_NAMES.SONIDOS_DE_LETRAS,
                score: 0,
            },
        ],
    },
};

export const getBMRecommendationRules = studentResults =>
    Object.keys(recommendationRules).reduce((recommendedRules, recommendedMeasure) => {
        const { rules } = recommendationRules[recommendedMeasure];
        return {
            ...recommendedRules,
            [recommendedMeasure]: {
                isRuleMet: rules.some(rule => {
                    const recommendationRule = bmRecommendationRuleFactory(rule);
                    return recommendationRule.getIsRuleMet(studentResults);
                }),
            },
        };
    }, {});
